const HEAD_LOCAL = "local";
const HEAD_ACTION = "action";
const HEAD_HTTP = "http";
const HEAD_HTTPS = "https";
const HEAD_MP = "mp";
const HEAD_PLUGIN = 'plugin';
const HEAD_REQUEST = "request";
const HEAD_REQUESTS = "requests";
const HEAD_PHONE = 'phone';
const HEAD_TOAST = "toast";
const HEAD_COPY = "copy";
const DIVIDER_HEAD = "://";
const DIVIDER_QMARLK = "?";
const KEY_HEAD = "head";
const KEY_PATH = "path";
const KEY_DATA = "data";
const KEY_SOURCE = "source";
const PHR_USERID = "{userid}";
const KEY_STS_DATA = "sts_data";

var lastLaunchTime = 0;
var globalUser = null;
var stparamMap = null;

const parse = function(protocal) {
	if (isEmpty(protocal)) {
		return null;
	}

	var data = new Array();
	data[KEY_SOURCE] = protocal;

	if (protocal.indexOf(HEAD_HTTP) == 0 || protocal.indexOf(HEAD_HTTPS) == 0) {
		data[KEY_HEAD] = HEAD_HTTP;
		data[KEY_DATA] = protocal;
		return data;
	}

	var headIndex = protocal.indexOf(DIVIDER_HEAD);

	if (headIndex == -1) {
		return null;
	}

	data[KEY_HEAD] = protocal.substring(0, headIndex);
	var qmarkIndex = protocal.indexOf(DIVIDER_QMARLK);

	if (qmarkIndex == -1) {
		data[KEY_PATH] = protocal.substring(headIndex + DIVIDER_HEAD.length);
		return data;
	} else {
		data[KEY_PATH] = protocal.substring(headIndex + DIVIDER_HEAD.length, qmarkIndex);
	}

	if (qmarkIndex < protocal.length - 1) {
		data[KEY_DATA] = protocal.substring(qmarkIndex + 1);
	}

	return data;
}

const handleProtocal = url => {
	console.log('protocal url', url)
	var route = parse(url);
	return handleRouteProtocal(route);
}

const handleRouteProtocal = route => {
	return new Promise(function(resolve, reject) {
		if (route == null) {
			resolve();
			return;
		}

		if (route['head'] == HEAD_HTTP || route['head'] == HEAD_HTTPS) {
			launchWebview(route[KEY_SOURCE], resolve);
		} else if (route['head'] == HEAD_LOCAL) {
			launchLocal(route, resolve, reject);
		}
	});
}

function launchLocal(route, resolve, reject) {
	var url = "/" + route['path'];

	if (route['data'] != null && route['data'].length != 0) {
		url += "?" + route['data'];
	}

	window.location.href = url;
}

function launchWebview(url, resolve) {
	// window.location.href = url;
	console.log('launchWebview-----')
	window.open(url, '_blank')
}

function isEmpty(str) {
	return str == null || str === '' || str == undefined || str == 'NULL';
}

function showToast(msg) {

}

function startWith(url, target) {
	if (isEmpty(url)) {
		return false;
	}

	return url.indexOf(target) == 0;
}

module.exports = {
	parse,
	handleProtocal,
	handleRouteProtocal,
}